"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");

class BaseSearchPaging extends React.Component {
	constructor(props) {
		super(props);

		var currentPageNumber = props.currentPageNumber;
		var pageSize = props.pageSize || 10;
		var totalCount = props.totalCount;

		if (props.isDesignMode) {
			currentPageNumber = 10;
			totalCount = 20 * pageSize;
		}

		this.state = {
			currentPageNumber,
			pageSize,
			totalCount
		};
	}

	setupRelatedComponents() {
		var currentPage = this.state.currentPageNumber;
		var lastPage = Math.ceil(this.state.totalCount / this.state.pageSize);

		var $searchPaging = $(ReactDOM.findDOMNode(this)).parent(); // The parent is the mount point
		var $previousButton = $searchPaging.siblings(this.props.previousPageSelector);
		var $nextButton = $searchPaging.siblings(this.props.nextPageSelector);

		if (currentPage > 1) {
			$previousButton.removeClass("disabled");
			$previousButton.prop("onclick", null).off("click");
			$previousButton.click(this.handlePageChange.bind(this, currentPage - 1));
		} else {
			$previousButton.addClass("disabled");
			$previousButton.prop("onclick", null).off("click");
		}

		if (currentPage < lastPage) {
			$nextButton.removeClass("disabled");
			$nextButton.prop("onclick", null).off("click");
			$nextButton.click(this.handlePageChange.bind(this, currentPage + 1));
		} else {
			$nextButton.addClass("disabled");
			$nextButton.prop("onclick", null).off("click");
		}
	}

	handlePageChange(pageNumber, event) {
		var currentPage = this.state.currentPageNumber;
		if (currentPage === pageNumber) {
			return;
		}
		if (this.props.isDesignMode) {
			if (event && !event.ctrlKey && !event.metaKey) {
				return;
			}
			this.setState({ currentPageNumber: pageNumber }, this.setupRelatedComponents);
			return;
		}

		this.props.onPageChange(pageNumber);
	}

	componentDidMount() {
		this.setupRelatedComponents();

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit JavaScript\searchComponents\expose.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit JavaScript\searchComponents\expose.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
		}
	}

	render() {
		var pageSize = this.state.pageSize;
		var currentPage = this.state.currentPageNumber;
		var numberPagesToShow = this.props.numberPagesToShow;
		var lastPage = Math.ceil(this.state.totalCount / pageSize);

		if (this.props.isDesignMode) {
			numberPagesToShow = numberPagesToShow || 3;
		}

		var pagesToShow = [];
		if (lastPage < numberPagesToShow) {
			pagesToShow = Array(lastPage).fill().map((e, i) => i + 1);
		} else if (currentPage < numberPagesToShow) {
			pagesToShow = Array(numberPagesToShow).fill().map((e, i) => i + 1);
		} else {
			var start = currentPage - Math.floor((numberPagesToShow - 1) / 2);
			if (start + numberPagesToShow > lastPage) {
				start = lastPage - numberPagesToShow + 1;
			}
			pagesToShow = Array(numberPagesToShow).fill().map((e, i) => i + start);
		}

		var includeFirstPageNumber = this.props.includeFirstPageNumber && pagesToShow.indexOf(1) === -1;
		var showStartEllipses = includeFirstPageNumber && pagesToShow.indexOf(2) === -1;
		var includeLastPageNumber = this.props.includeLastPageNumber && pagesToShow.indexOf(lastPage) === -1;
		var showEndEllipses = includeLastPageNumber && pagesToShow.indexOf(lastPage - 1) === -1;

		return (
			<div
				className={this.props.className}
				data-react-component-name={this.props.dataReactComponentName}
				data-react-component-category={this.props.dataReactComponentCategory}
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				{includeFirstPageNumber &&
					<span className={classNames("paging-item page-number", { "current-page": currentPage === 1 })} data-component={`${this.props.dataReactComponentName}.page`} onClick={this.handlePageChange.bind(this, 1)}>
						{1}
					</span>
				}
				{showStartEllipses &&
					<span className="paging-item ellipses" data-component={`${this.props.dataReactComponentName}.pageEllipses`}>
						...
					</span>
				}
				{pagesToShow.map((pageNumber) =>
					<span key={pageNumber} className={classNames("paging-item page-number", { "current-page": currentPage === pageNumber })} data-component={`${this.props.dataReactComponentName}.page`} onClick={this.handlePageChange.bind(this, pageNumber)}>
						{pageNumber}
					</span>
				)}
				{showEndEllipses &&
					<span className="paging-item ellipses" data-component={`${this.props.dataReactComponentName}.pageEllipses`}>
						...
					</span>
				}
				{includeLastPageNumber &&
					<span className={classNames("paging-item page-number", { "current-page": currentPage === lastPage })} data-component={`${this.props.dataReactComponentName}.page`} onClick={this.handlePageChange.bind(this, lastPage)}>
						{lastPage}
					</span>
				}
			</div>
		);
	}
}

BaseSearchPaging.propTypes = {
	isDesignMode: PropTypes.bool,
	dataChildOf: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataRepeatedId: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,

	numberPagesToShow: PropTypes.number,
	includeFirstPageNumber: PropTypes.bool,
	includeLastPageNumber: PropTypes.bool,
	currentPageNumber: PropTypes.number,
	pageSize: PropTypes.number,
	totalCount: PropTypes.number,

	className: PropTypes.string,
	dataReactComponentCategory: PropTypes.string.isRequired,
	dataReactComponentName: PropTypes.string.isRequired,
	nextPageSelector: PropTypes.string.isRequired,
	onPageChange: PropTypes.func.isRequired,
	previousPageSelector: PropTypes.string.isRequired,
	thisArg: PropTypes.object
};

module.exports = BaseSearchPaging;
